import { Grid } from '@material-ui/core';
import { useAppSelector } from '../../../../app/hooks';
import Card from '../../../../components/Card/Card';
import FieldGroup from '../../../../components/FieldGroup/FieldGroup';
import { selectDomicilio } from '../../consultaCompletaSlice';

const CaracteristicasDomicilio: React.FC = () => {
  const domicilio = useAppSelector(selectDomicilio);

  return (
    <>
      {domicilio && (
        <Card>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FieldGroup label="Área" value={domicilio.tipoLocalDomicilio?.nome} />
            </Grid>
            <Grid item xs={8}>
              <FieldGroup label="Tipo" value={domicilio.tipoEspecieDomicilio?.nome} grow2 />
            </Grid>
            {domicilio.tipoEspecieDomicilio?.codigo !== 2 && domicilio.tipoEspecieDomicilio?.codigo !== 3 && (
              <>
                <Grid item xs={4}>
                  <FieldGroup label="Cômodos" value={domicilio.quantidadeComodos} />
                </Grid>
                <Grid item xs={8}>
                  <FieldGroup
                    label="Cômodos usados para dormir"
                    value={domicilio.quantidadeComodosDormitorio}
                    grow2
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Material do piso"
                    value={domicilio.tipoMaterialPisoDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Material das paredes externas"
                    value={domicilio.tipoMaterialParedeDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Água canalizada para, pelo menos, um cômodo"
                    value={domicilio.possuiAguaCanalizada?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Forma de abastecimento de água"
                    value={domicilio.tipoAbastecimentoDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Existe banheiro ou sanitário"
                    value={domicilio.possuiBanheiroDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Forma de escoamento do banheiro ou sanitário"
                    value={domicilio.tipoEscoamentoDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Destino do lixo do domicílio"
                    value={domicilio.tipoDestinoLixoDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Forma de iluminação do domicílio"
                    value={domicilio.tipoIluminacaoDomicilio?.nome}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldGroup
                    label="Pavimentação em frente ao domicílio"
                    value={domicilio.tipoCalcamentoDomicilio?.nome}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Card>
      )}
    </>
  );
};

export default CaracteristicasDomicilio;
